const grade_1 = {
  label: "Grade 1",
  subjects: {

     applied_design_1: {
  label: "Applied Design ( Grade 1)",
 topics: [
    // { value: "defining", label: "Defining" },
    { value: "ideating", label: "Ideating" },
    // { value: "prototyping", label: "Prototyping" },
    // { value: "testing", label: "Testing" },
    { value: "making", label: "Making" },
    { value: "sharing", label: "Sharing" },
    { value: "applied_skills", label: "Applied Skills" },
    { value: "applied_technologies", label: "Applied Technologies" }
  ],
  competencies: {
    core: [
       { value: "ideating", label: "Ideating" },
    // { value: "prototyping", label: "Prototyping" },
    // { value: "testing", label: "Testing" },
    { value: "making", label: "Making" },
    { value: "sharing", label: "Sharing" },
    { value: "applied_skills", label: "Applied Skills" },
    { value: "applied_technologies", label: "Applied Technologies" }
    ],
    sub: {
      applied_design: [
        // Defining
        {
          value: "identify_needs_opportunities",
          label: "Identify needs and opportunities for designing, through exploration"
        },

        // Ideating
        {
          value: "generate_ideas",
          label: "Generate ideas from their experiences and interests"
        },
        {
          value: "add_to_others_ideas",
          label: "Add to others’ ideas"
        },
        {
          value: "choose_idea",
          label: "Choose an idea to pursue"
        },

        // Prototyping
        {
          value: "choose_tools_materials",
          label: "Choose tools and materials"
        },
        {
          value: "make_product",
          label: "Make a product using known procedures or through modelling of others"
        },

        // Testing
        {
          value: "trial_and_error",
          label: "Use trial and error to make changes, solve problems, or incorporate new ideas from self or others"
        },

        // Making
        {
          value: "decide_sharing",
          label: "Decide on how and with whom to share their product"
        },

        // Sharing
        {
          value: "demonstrate_product",
          label: "Demonstrate their product, tell the story of designing and making their product, and explain how their product contributes to the individual, family, community, and/or environment"
        },
        {
          value: "evaluate_design_solution",
          label: "Use personal preferences to evaluate the success of their design solutions"
        },
        {
          value: "reflect_on_ability",
          label: "Reflect on their ability to work effectively both as individuals and collaboratively in a group"
        }
      ],

      applied_skills: [
        {
          value: "safe_use_tools",
          label: "Use materials, tools, and technologies in a safe manner in both physical and digital environments"
        },
        {
          value: "develop_skills_play",
          label: "Develop their skills and add new ones through play and collaborative work"
        }
      ],

      applied_technologies: [
        {
          value: "explore_simple_tools",
          label: "Explore the use of simple, available tools and technologies to extend their capabilities"
        }
      ]
    }
  }
},

  
  "arts_1": {
    "label": "Arts Education (Grade 1)",
   topics: [
        { value: "Expanding and Creating", label: "Expanding and Creating" },
        { value: "reasoning_reflecting", label: "Reasoning and Reflecting" },
        { value: "communicating_documenting", label: "Communicating and Documenting" },
        // { value: "connecting_expanding", label: "Connecting and Expanding" }
      ],
      competencies: {
        core: [
          { value: "Exploring", label: "Expanding and Creating" },
          { value: "Reasoning", label: "Reasoning and Reflecting" },
          { value: "Communicating", label: "Communicating and Documenting" },
          // { value: "Connecting", label: "Connecting and Expanding" }
        ],

      "sub": {
        "exploring_creating": [
          {
            "value": "explore_elements_processes",
            "label": "Explore elements, processes, materials, movements, technologies, tools, and techniques of the arts"
          },
          {
            "value": "create_artistic_works",
            "label": "Create artistic works collaboratively and as an individual using ideas inspired by imagination, inquiry, experimentation, and purposeful play"
          },
          {
            "value": "explore_artistic_expressions",
            "label": "Explore artistic expressions of themselves and community through creative processes"
          }
        ],

        "reasoning_reflecting": [
          {
            "value": "observe_share_artist_use",
            "label": "Observe and share how artists use processes, materials, movements, technologies, tools, and techniques"
          },
          {
            "value": "develop_processes_skills",
            "label": "Develop processes and technical skills in a variety of art forms to nurture motivation, development, and imagination"
          },
          {
            "value": "reflect_connect_experiences",
            "label": "Reflect on creative processes and make connections to other experiences"
          }
        ],

        "communicating_documenting": [
          {
            "value": "interpret_symbols_express_meaning",
            "label": "Interpret symbols and how they can be used to express meaning through the arts"
          },
          {
            "value": "express_feelings_ideas",
            "label": "Express feelings, ideas, stories, observations, and experiences through the arts"
          },
          {
            "value": "describe_respond_artworks",
            "label": "Describe and respond to works of art"
          }
        ],

        "connecting_expanding": [
          {
            "value": "experience_document_share",
            "label": "Experience, document, and share creative works in a variety of ways"
          },
          {
            "value": "demonstrate_application_content",
            "label": "Demonstrate increasingly sophisticated application and/or engagement of curricular content"
          }
        ]
      }
    }
  }
,

   career_education_1: {
      label: 'Career Education (Grade 1)',
      topics: [],
      competencies: {
        core: [
          { value: 'examine', label: 'Examine' },
          { value: 'interact', label: 'Interact' },
          { value: 'experience', label: 'Experience' },
          { value: 'initiate', label: 'Initiate' },
          { value: 'share', label: 'Share' }
        ],
        sub: {
          examine: [
            { value: 'identify_and_appreciate_personal_attributes', label: 'Identify and appreciate their personal attributes, skills, interests, and accomplishments' },
            { value: 'demonstrate_effective_work_habits', label: 'Demonstrate effective work habits and organizational skills appropriate to their level of development' }
          ],
          interact: [
            { value: 'work_respectfully_and_constructively', label: 'Work respectfully and constructively with others to achieve common goals' },
            { value: 'identify_and_appreciate_roles_and_responsibilities', label: 'Identify and appreciate the roles and responsibilities of people in their schools, families, and communities' },
            { value: 'recognize_the_importance_of_positive_relationships', label: 'Recognize the importance of positive relationships in their lives' }
          ],
          experience: [
            { value: 'recognize_the_importance_of_learning', label: 'Recognize the importance of learning in their lives and future careers' }
          ],
          initiate: [
            { value: 'set_and_achieve_realistic_learning_goals', label: 'Set and achieve realistic learning goals for themselves' }
          ],
          share: [
            { value: 'share_ideas_information_feelings_and_knowledge', label: 'Share ideas, information, personal feelings, and knowledge with others' },
            { value: 'recognize_the_basic_skills_required', label: 'Recognize the basic skills required in a variety of jobs in the community' }
          ]
        }
      }
    },

  "english_1": {
    "label": "English Language Arts (Grade 1)",
    "topics": [
      { "value": "comprehend_connect", "label": "Comprehend and Connect (Reading, Listening, Viewing)" },
      { "value": "create_communicate", "label": "Create and Communicate (Writing, Speaking, Representing)" }
    ],
    "competencies": {
      "core": [
        { "value": "comprehend_connect", "label": "Comprehend and Connect (reading, listening, viewing)" },
        { "value": "create_communicate", "label": "Create and Communicate (writing, speaking, representing)" }
      ],
      "sub": {
        "comprehend_connect": [
          {
            "value": "read_fluently_grade_level",
            "label": "Read fluently at grade level (Grade 1–3)"
          },
          {
            "value": "use_sources_prior_knowledge",
            "label": "Use sources of information and prior knowledge to make meaning (K-3)"
          },
          {
            "value": "use_read_listen_view_strategies",
            "label": "Use developmentally appropriate reading, listening, and viewing strategies to make meaning (K-3)"
          },
          {
            "value": "use_foundational_concepts",
            "label": "Use foundational concepts of print, oral, and visual texts"
          },
          {
            "value": "engage_actively",
            "label": "Engage actively as listeners, viewers, and readers to develop understanding of self, identity, and community (K-3)"
          },
          {
            "value": "recognize_importance_of_story",
            "label": "Recognize the importance of story in personal, family, and community identity (K-1)"
          },
          {
            "value": "use_personal_experience_connections",
            "label": "Use personal experience and knowledge to connect to stories and other texts to make meaning (K-2)"
          },
          {
            "value": "recognize_structure_elements_story",
            "label": "Recognize the structure and elements of story (Grade 1–3)"
          },
          {
            "value": "awareness_fp_story_connections",
            "label": "Show awareness of how story in First Peoples cultures connects people to family and community (Grade 1–3)"
          }
        ],

        "create_communicate": [
          {
            "value": "exchange_ideas_perspectives",
            "label": "Exchange ideas and perspectives to build shared understanding (K-5)"
          },
          {
            "value": "identify_organize_present",
            "label": "Identify, organize, and present ideas in a variety of forms"
          },
          {
            "value": "create_stories_texts_awareness",
            "label": "Create stories and other texts to deepen awareness of self, family, and community (K-3)"
          },
          {
            "value": "plan_create_variety_forms",
            "label": "Plan and create a variety of communication forms for different purposes and audiences (Grade 1–3)"
          },
          {
            "value": "communicate_using_conventions",
            "label": "Communicate using letters and words and applying some conventions of Canadian spelling, grammar, and punctuation"
          },
          {
            "value": "explore_oral_storytelling",
            "label": "Explore oral storytelling processes (K-2)"
          }
        ]
      }
    }
  }
,
 "math_1": {
    "label": "Mathematics (Grade 1)",
    "topics": [
      { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
      { "value": "understanding_solving", "label": "Understanding and Solving" },
      { "value": "communicating_representing", "label": "Communicating and Representing" },
      { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
    ],

    "competencies": {
      "core": [
        { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
        { "value": "understanding_solving", "label": "Understanding and Solving" },
        { "value": "communicating_representing", "label": "Communicating and Representing" },
        { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
      ],

      "sub": {
        "reasoning_analyzing": [
          {
            "value": "use_reasoning_make_connections_k5",
            "label": "Use reasoning to explore and make connections"
          },
          {
            "value": "estimate_reasonably_k5",
            "label": "Estimate reasonably"
          },
          {
            "value": "develop_mental_math_strategies_k5",
            "label": "Develop mental math strategies and abilities to make sense of quantities"
          },
          {
            "value": "use_technology_explore_math_k5",
            "label": "Use technology to explore mathematics"
          }
        ],

        "understanding_solving": [
          {
            "value": "model_mathematics_context_k5",
            "label": "Model mathematics in contextualized experiences"
          },
          {
            "value": "apply_understanding_play_inquiry_k5",
            "label": "Develop, demonstrate, and apply mathematical understanding through play, inquiry, and problem solving"
          },
          {
            "value": "visualize_explore_math_concepts_k5",
            "label": "Visualize to explore mathematical concepts"
          },
          {
            "value": "use_multiple_problem_solving_strategies_k5",
            "label": "Develop and use multiple strategies to engage in problem solving"
          },
          {
            "value": "connect_problem_solving_local_culture_k5",
            "label": "Engage in problem-solving experiences connected to place, story, cultural practices, and perspectives relevant to local First Peoples communities, the local community, and other cultures"
          }
        ],

        "communicating_representing": [
          {
            "value": "communicate_math_thinking_k5",
            "label": "Communicate mathematical thinking in many ways"
          },
          {
            "value": "use_math_vocabulary_k5",
            "label": "Use mathematical vocabulary and language to contribute to mathematical discussions"
          },
          {
            "value": "explain_justify_math_ideas_k5",
            "label": "Explain and justify mathematical ideas and decisions"
          },
          {
            "value": "represent_math_ideas_k5",
            "label": "Represent mathematical ideas in concrete, pictorial, and symbolic forms"
          }
        ],

        "connecting_reflecting": [
          {
            "value": "reflect_math_thinking_k5",
            "label": "Reflect on mathematical thinking"
          },
          {
            "value": "connect_math_concepts_k5",
            "label": "Connect mathematical concepts to each other and to other areas and personal interests"
          },
          {
            "value": "incorporate_first_peoples_perspectives_k5",
            "label": "Incorporate First Peoples worldviews and perspectives to make connections to mathematical concepts"
          }
        ]
      }
    }
  },

 "phe_1": {
    "label": "Physical and Health Education (Grade 1)",
    "topics": [
      { "value": "physical_literacy", "label": "Physical Literacy" },
      { "value": "healthy_active_living", "label": "Healthy and Active Living" },
      { "value": "social_community_health", "label": "Social and Community Health" },
      { "value": "mental_well_being", "label": "Mental Well-Being" }
    ],

    "competencies": {
      "core": [
        { "value": "physical_literacy", "label": "Physical Literacy" },
        { "value": "healthy_active_living", "label": "Healthy and Active Living" },
        { "value": "social_community_health", "label": "Social and Community Health" },
        { "value": "mental_well_being", "label": "Mental Well-Being" }
      ],

      "sub": {
        "physical_literacy": [
          {
            "value": "fundamental_movement_skills_1",
            "label": "Develop and demonstrate a variety of fundamental movement skills in a variety of physical activities and environments (K–2)"
          },
          {
            "value": "describe_body_reaction_1",
            "label": "Describe the body’s reaction to participating in physical activity (K–1)"
          },
          {
            "value": "safety_fair_play_leadership_1",
            "label": "Develop and demonstrate safety, fair play, and leadership in physical activities (K–9)"
          }
        ],

        "healthy_active_living": [
          {
            "value": "participate_daily_activity_1",
            "label": "Participate daily in physical activity at moderate to vigorous intensity levels (K–4)"
          },
          {
            "value": "identify_opportunities_activity_1",
            "label": "Identify opportunities to be physically active at school, home, and in the community (K–1)"
          },
          {
            "value": "identify_explore_foods_1",
            "label": "Identify and explore a variety of foods and describe how they contribute to health (K–1)"
          },
          {
            "value": "identify_choices_health_1",
            "label": "Identify opportunities to make choices that contribute to health and well-being (K–1)"
          },
          {
            "value": "recognize_health_info_1",
            "label": "Recognize basic health information from a variety of sources"
          }
        ],

        "social_community_health": [
          {
            "value": "prevent_respond_unsafe_situations_1",
            "label": "Describe ways to prevent and respond to unsafe and/or uncomfortable situations"
          },
          {
            "value": "demonstrate_respectful_behaviour_1",
            "label": "Develop and demonstrate respectful behaviour in activities with others (K–2)"
          },
          {
            "value": "identify_caring_behaviours_1",
            "label": "Identify caring behaviours among classmates and families (K–1)"
          }
        ],

        "mental_well_being": [
          {
            "value": "practices_promote_mental_well_being_1",
            "label": "Identify and describe practices that promote mental well-being (K–1)"
          },
          {
            "value": "identify_feelings_worries_1",
            "label": "Identify and describe feelings and worries (K–1)"
          },
          {
            "value": "identify_personal_skills_interests_1",
            "label": "Identify personal skills, interests, and preferences (K–1)"
          }
        ]
      }
    }
  }
  ,
 


    science_1: {
      label: "Science (Grade 1)",
      topics: [
        { value: "living_things", label: "Living and Non-Living Things" },
        { value: "weather", label: "Weather Patterns" },
        { value: "senses", label: "Five Senses" }
      ],
      competencies: {
        core: [
          { value: "Predicting", label: "Questioning and Predicting" },
          { value: "Conducting", label: "Planning and Conducting" },
          { value: "Processing", label: "Processing and Analyzing Data and Information" },
          { value: "Evaluating", label: "Evaluating" },
          { value: "Applying", label: "Applying and Innovating" },
          { value: "Communicating", label: "Communicating" },
        ],
        sub: {
          Predicting: [
            { value: "using_senses", label: "Demonstrate curiosity and a sense of wonder about the world" },
            { value: "describing", label: "Observe objects and events in familiar contexts" },
            { value: "recording", label: "Ask questions about familiar objects and events" },
            { value: "recording", label: "Make simple predictions about familiar objects and events" }
          ],
          Conducting: [
            { value: "asking_questions", label: "Make and record observations" },
            { value: "making_predictions", label: "Safely manipulate materials to test ideas and predictions" },
            { value: "exploring", label: "Make and record simple measurements using informal or non-standard methods" }
          ],
          Processing: [
            { value: "using_senses", label: "Experience and interpret the local environment" },
            { value: "describing", label: "Recognize First Peoples stories, songs, and art as ways to share knowledge" },
            { value: "recording", label: "Sort and classify data and information using drawings, pictographs, and provided tables" },
            { value: "recording", label: "Compare observations with predictions through discussion" },
            { value: "recording", label: "Identify simple patterns and connections" },
            { value: "recording", label: "Compare observations with those of others" }
          ],
          Innovatinguating: [
            { value: "asking_questions", label: "Take part in caring for self, family, classroom, and school through personal approaches" },
            { value: "making_predictions", label: "Transfer and apply learning to new situations" },
            { value: "exploring", label: "Generate and introduce new or refined ideas when problem solving" }
          ],
          Evaluating: [
            { value: "using_senses", label: "Consider some environmental consequences of their actions" },
          ],
          Applying: [
            { value: "asking_questions", label: "Asking Questions" },
            { value: "making_predictions", label: "Making Predictions" },
            { value: "exploring", label: "Hands-on Exploration" }
          ],
          Communicating: [
            { value: "using_senses", label: "Communicate observations and ideas using oral or written language, drawing, or role-play" },
            { value: "describing", label: "Express and reflect on personal experiences of place" },
          ],
        }
      }
    },
   
 

  "social_studies_1": {
    "label": "Social Studies (Grade 1)",
     "topics": [
      { "value": "inquiry", "label": "Inquiry" },
      { "value": "significance", "label": "Significance" },
      { "value": "evidence", "label": "Evidence" },
      { "value": "continuity_change", "label": "Continuity and Change" },
      { "value": "cause_consequence", "label": "Cause and Consequence" },
      { "value": "perspective", "label": "Perspective" },
      { "value": "ethical_judgement", "label": "Ethical Judgement" }
    ],

    "competencies": {
      "core": [
        { "value": "inquiry", "label": "Inquiry" },
        { "value": "significance", "label": "Significance" },
        { "value": "evidence", "label": "Evidence" },
        { "value": "continuity_change", "label": "Continuity and Change" },
        { "value": "cause_consequence", "label": "Cause and Consequence" },
        { "value": "perspective", "label": "Perspective" },
        { "value": "ethical_judgement", "label": "Ethical Judgement" }
      ],

      "sub": {
        "inquiry": [
          {
            "value": "inquiry_process_ss1",
            "label": "Use Social Studies inquiry processes and skills to ask questions; gather, interpret, and analyze ideas; and communicate findings and decisions"
          }
        ],

        "significance": [
          {
            "value": "explain_significance_ss1",
            "label": "Explain the significance of personal or local events, objects, people, or places"
          }
        ],

        "evidence": [
          {
            "value": "ask_infer_conclude_ss1",
            "label": "Ask questions, make inferences, and draw conclusions about the content and features of different types of sources"
          }
        ],

        "continuity_change": [
          {
            "value": "sequence_distinguish_change_ss1",
            "label": "Sequence objects, images, or events, and distinguish between what has changed and what has stayed the same"
          }
        ],

        "cause_consequence": [
          {
            "value": "recognize_cause_effect_ss1",
            "label": "Recognize causes and consequences of events, decisions, or developments in their lives"
          }
        ],

        "perspective": [
          {
            "value": "explore_perspectives_ss1",
            "label": "Explore different perspectives on people, places, issues, or events in their lives"
          }
        ],

        "ethical_judgement": [
          {
            "value": "identify_fair_unfair_ss1",
            "label": "Identify fair and unfair aspects of events, decisions, or actions"
          }
        ]
      }
    }
  },

 

}


    
  


    
  };

export default grade_1;
